import { render, staticRenderFns } from "./ConfigProposals.vue?vue&type=template&id=313bd528&"
import script from "./ConfigProposals.vue?vue&type=script&lang=js&"
export * from "./ConfigProposals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports